import { INTEGRATIONS_ACTIONS } from './integrations.types'

/**
 *
 * @param {import('./integrations.types').IntegrationsSlice['status']} payload
 * @returns {import('./integrations.types').IntegrationsStatusAction}
 */
export const setIntegrationsStatusAction = payload => ({
  type: INTEGRATIONS_ACTIONS.SET_INTEGRATIONS_STATUS,
  payload
})

/**
 *
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./integrations.types').IntegrationsErrorsAction}
 */
export const setIntegrationsErrorsAction = payload => ({
  type: INTEGRATIONS_ACTIONS.SET_INTEGRATIONS_ERRORS,
  payload
})

/**
 *
 * @param {import('./integrations.types').IntegrationsData} payload
 * @returns {import('./integrations.types').IntegrationsDataAction}
 */
export const setIntegrationsDataAction = payload => ({
  type: INTEGRATIONS_ACTIONS.SET_INTEGRATIONS_DATA,
  payload
})

/**
 * @param {import('./integrations.types').IntegrationsSlice['mode']} payload
 * @returns {import('./integrations.types').IntegrationsModeAction}
 */
export const setIntegrationsModeAction = payload => ({
  type: INTEGRATIONS_ACTIONS.SET_INTEGRATIONS_MODE,
  payload
})

/**
 * @returns {import('./integrations.types').IntegrationsClearAction}
 */
export const clearIntegrationsErrorsAction = () => ({ type: INTEGRATIONS_ACTIONS.CLEAR_INTEGRATIONS_ERRORS })

/**
 * @returns {import('./integrations.types').IntegrationsClearAction}
 */
export const clearIntegrationsDataAction = () => ({ type: INTEGRATIONS_ACTIONS.CLEAR_INTEGRATIONS_DATA })
